// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/envelope.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'envelope',
  version: 'outline',
  paths: [
    {
      d: 'M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75',
    },
  ],
}
